/**
 * @generated SignedSource<<4a04910789136edaeaf3192212b2d7f4>>
 * @relayHash 1c1e86bc2e558205948bdf744eb7a2bb
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b0b9a251b511006bf5632e1c7732f82915b44a15a13db2b507334d6dbdc39248

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type graphGeneralSettingsPageQuery$variables = {
  account: string;
  graph: string;
};
export type graphGeneralSettingsPageQuery$data = {
  readonly graph: {
    readonly " $fragmentSpreads": FragmentRefs<"graphIdFragment" | "graphNameFragment">;
  };
};
export type graphGeneralSettingsPageQuery = {
  response: graphGeneralSettingsPageQuery$data;
  variables: graphGeneralSettingsPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "account"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "graph"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "accountSlug",
    "variableName": "account"
  },
  {
    "kind": "Variable",
    "name": "graphSlug",
    "variableName": "graph"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "graphGeneralSettingsPageQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": "graph",
          "args": (v1/*: any*/),
          "concreteType": "Graph",
          "kind": "LinkedField",
          "name": "graphByAccountSlug",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "graphNameFragment"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "graphIdFragment"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "graphGeneralSettingsPageQuery",
    "selections": [
      {
        "alias": "graph",
        "args": (v1/*: any*/),
        "concreteType": "Graph",
        "kind": "LinkedField",
        "name": "graphByAccountSlug",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1c1e86bc2e558205948bdf744eb7a2bb",
    "id": "b0b9a251b511006bf5632e1c7732f82915b44a15a13db2b507334d6dbdc39248",
    "metadata": {},
    "name": "graphGeneralSettingsPageQuery",
    "operationKind": "query",
    "text": "query graphGeneralSettingsPageQuery(\n  $account: String!\n  $graph: String!\n) {\n  graph: graphByAccountSlug(accountSlug: $account, graphSlug: $graph) {\n    ...graphNameFragment\n    ...graphIdFragment\n    id\n  }\n}\n\nfragment graphIdFragment on Graph {\n  id\n}\n\nfragment graphNameFragment on Graph {\n  id\n  slug\n  account {\n    __typename\n    slug\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "84f402d849198ae1413c4886ddf86c2a";

export default node;
